/**
 * DOM HUD: top-left user info box + a tiny dev status string.
 * Mirrors the layout of amgcommon_v2's `UserInfoDisplay`
 * (referenced from game_screen.dart:872-882).
 *
 * The Rive layer also pushes balance into the artboard's `txtBalance` text
 * run (see RiveLayer.setBalanceText); this DOM display is the always-visible
 * fallback / debug surface, and the place we show username.
 */
function fmtCurrency(n: number): string {
  return Math.round(n).toLocaleString('en-US');
}

export class Hud {
  private readonly statusEl: HTMLElement;
  private readonly userInfoEl: HTMLElement;
  private readonly userNameEl: HTMLElement;
  private readonly balanceEl: HTMLElement;

  constructor() {
    const host = document.getElementById('dom-hud');
    if (!host) throw new Error('Hud: #dom-hud missing');

    // Tiny dev status line at top-center.
    this.statusEl = document.createElement('div');
    this.statusEl.className = 'hud-status';
    this.statusEl.textContent = 'Loading…';
    host.appendChild(this.statusEl);

    // Top-left user info box.
    this.userInfoEl = document.createElement('div');
    this.userInfoEl.className = 'user-info';

    this.userNameEl = document.createElement('div');
    this.userNameEl.className = 'ui-user';
    this.userNameEl.textContent = '—';

    this.balanceEl = document.createElement('div');
    this.balanceEl.className = 'ui-balance';
    this.balanceEl.textContent = '0';

    const label = document.createElement('div');
    label.className = 'ui-balance-label';
    label.textContent = 'Balance';

    this.userInfoEl.append(this.userNameEl, this.balanceEl, label);
    host.appendChild(this.userInfoEl);
  }

  setStatus(text: string): void {
    this.statusEl.textContent = text;
  }

  setUserName(userName: string): void {
    this.userNameEl.textContent = userName || '—';
  }

  /** Update the displayed balance. */
  setBalance(n: number): void {
    this.balanceEl.textContent = fmtCurrency(n);
  }

  /** Bet total no longer rendered in the HUD — handled by Rive text run. */
  setBetTotal(_n: number): void {
    /* no-op */
  }
}
